angular.module("ainapp").controller("addStockJVController", [
    "app.config",
    "$scope",
    "AuthenticationService",
    "$state",
    "$stateParams",
    "MainService",
    "localStorageService",
    function (config, $scope, AuthenticationService, $state, $stateParams, MainService, localStorageService) {
        $scope.PageName = "Add Stock JV";
        $scope.TokenInfo = AuthenticationService.getTokenInfo();
        if ($scope.TokenInfo == null) {
            $state.go("login");
        } else {
            $scope.checkUserPageAccess($scope.PageName);
        }

        $scope.Warehouses = [];
        MainService.WarehousesInDropdown().then(function (response) {
            $scope.Warehouses = response.data;
        });

        $scope.VDesign = {};
        MainService.VoucherDesignsbyType("Stock JV").then(function (response) {
            $scope.VDesign = response.data;
        });

        $scope.VoucherSet = {};
        MainService.VoucherAccountsbyType("Stock JV").then(function (response) {
            $scope.VoucherSet = response.data;
        });

        $scope.PrintSetting = {};
        MainService.PrintSettingsbyType("Stock JV").then(function (response) {
            $scope.PrintSetting = response.data;
        });

        $scope.TableDesign = {};
        $scope.ColumnWidth = null;
        MainService.TableDesignsbyVoucher("Stock JV").then(function (response) {
           if (response.data != null && response.data != "") {
                $scope.TableDesign = response.data;
                $scope.ColumnWidth = JSON.parse(response.data.ColumnWidth);
            }
        });

        $scope.getExtramasters();

        $scope.loadVoucher = function (id) {
            $.LoadingOverlay("show", {
                image: "images/load.gif"
            });
            MainService.getStockJVbyId(id).then(
                function (response) {
                    if (response.data) {
                        if ($scope.isClone) {
                            MainService.GetNextStockJVNo().then(function (response2) {
                                $scope.AccountNumber = response2.data;
                                response.data[0].Id = "";
                                response.data[0].Date = new Date();
                                $scope.UpdateDetails(response.data[0]);
                            });
                            $scope.isClone = false;
                        } else {
                            $scope.UpdateDetails(response.data[0]);
                            $scope.AccountNumber = response.data[0].VoucherNo;
                        }
                    }
                    $.LoadingOverlay("hide");
                },
                function (err) {
                    toastr.error("NetworkError");
                    $.LoadingOverlay("hide");
                }
            );
        };

        $scope.cloneVoucher = function () {
            $scope.isClone = true;
            $scope.loadVoucher($scope.StockIssue.Id);
        };

        $scope.UpdateDetails = function (data) {
            $scope.StockIssue = data;

            $scope.StockIssue.Date = new Date(data.Date);
            $scope.VoucherDocs = data.VoucherDocs;

            angular.forEach(data.StockJVCosts, function (e) {
                angular.forEach($scope.CostCenters, function (a) {
                    if (e.CostCenter.ParentId == a.CostCenterId) {
                        a.SelectedCostCenterId = e.CostCenter.Id;
                    }
                });
            });

            angular.forEach($scope.StockIssue.StockJVDetails, function (e) {

                if($scope.StockIssue.Id == 0){
                    $scope.click(e, 1);
                }

                var costs = angular.copy($scope.CostCenters);
                if (e.StockJVCosts.length > 0) {
                    angular.forEach(e.StockJVCosts, function (ee) {
                        angular.forEach(costs, function (a) {
                            if (ee.CostCenter.ParentId == a.CostCenterId) {
                                a.SelectedCostCenterId = ee.CostCenter.Id;
                            }
                        });
                        e.CostCenters = angular.copy(costs);
                    });
                } else {
                    e.CostCenters = angular.copy($scope.CostCenters);
                }
            });

            if (data.StockJVDetails.length <= 5) {
                var temp2 = 5 - data.StockJVDetails.length;

                for (var i = 0; i < temp2; i++) {
                    var StockJVDetails = {
                        Id: 0,
                        Quantity: 0,
                        UnitPrice: 0,
                        TotalAmount: 0,
                        UnitId: "",
                        StockType: "",
                        Field1: 0,
                        Field2: 0,
                        Field3: 0,
                        Field4: 0,
                        Field5: 0,
                        ProductId: "",
                        Remark: "",
                        Product: {},
                        CostCenters: angular.copy($scope.CostCenters)
                    };

                    if ($scope.CompanyProfile.DefaultWarehouseId > 0) {
                        StockJVDetails.WarehouseId = $scope.CompanyProfile.DefaultWarehouseId;
                    }

                    $scope.StockIssue.StockJVDetails.push(StockJVDetails);
                }
            }
        };

        $scope.expand = function () {
            $scope.expandView = !$scope.expandView;
        };

        $scope.VoucherSet = {};
        MainService.VoucherAccountsbyType("Stock JV").then(function (response) {
            $scope.VoucherSet = response.data;
        });

         $scope.tableReorderColumnArray = [];
            $scope.ReArrangeTable = function () {
                $scope.RearrangeReqired = false;
                $scope.tableReorderColumnArray = [];

                if ($scope.ColumnWidth != null) {
                    document.querySelectorAll('#rearrangeTable th[data-key], #rearrangeTable td[data-key]').forEach(cell => {
                        let key = cell.getAttribute('data-key');
                        if ($scope.ColumnWidth[key] !== undefined) {
                            cell.style.width = $scope.ColumnWidth[key] + "px";
                        }
                    });
                } else {
                    toastr.info("Table Width Adjustment Empty, Applying Default Width")
                    document.querySelectorAll('#rearrangeTable th[data-key], #rearrangeTable td[data-key]').forEach(cell => {
                        cell.style.width = "100px";
                    });
                }
            };

        $scope.init = function () {
            $scope.expandView = false;

            var tdate = new Date();
            var year = tdate.getFullYear();
            var month = tdate.getMonth();
            var day = tdate.getDate();
            var ndate = new Date(year + 1, month, day);

            $scope.ViewVal = 0;
            $scope.Load = false;
            $scope.ErrorText = "";

            $scope.print = {
                IsPrint: false
            };

            $scope.StockIssue = {
                Date: new Date(),
                Remark: "",
                CustomerId: "",
                VoucherNo: "",
                TotalQuantity: 0,
                TotalAmount: 0,
                StockJVDetails: []
            };

            if ($stateParams.VoucherId > 0) {
                MainService.GetCompanyProfile().then(function (response) {
                    $scope.CompanyProfile = response.data;
                    $scope.CostCenters = [];
                    MainService.CostCentersInVoucher("Stock JV").then(function (response) {
                        $scope.CostCenters = response.data;
                        $scope.loadVoucher($stateParams.VoucherId);
                    });
                });
            } else {
                $scope.CompanyProfile = {};
                MainService.GetCompanyProfile().then(function (response) {
                    $scope.CompanyProfile = response.data;

                    for (var i = 0; i < 5; i++) {
                        var StockJVDetails = {
                            Id: 0,
                            Quantity: 0,
                            UnitPrice: 0,
                            TotalAmount: 0,
                            UnitId: "",
                            StockType: "",
                            Field1: 0,
                            Field2: 0,
                            Field3: 0,
                            Field4: 0,
                            Field5: 0,
                            ProductId: "",
                            Remark: "",
                            Product: {}
                        };

                        if ($scope.CompanyProfile.DefaultWarehouseId > 0) {
                            StockJVDetails.WarehouseId = $scope.CompanyProfile.DefaultWarehouseId;
                        }

                        $scope.StockIssue.StockJVDetails.push(StockJVDetails);
                    }

                    $scope.CostCenters = [];
                    MainService.CostCentersInVoucher("Stock JV").then(function (response) {
                        $scope.CostCenters = response.data;

                        $scope.AccountNumber = "";
                        MainService.GetNextStockJVNo().then(function (response) {
                            $scope.AccountNumber = response.data;
                            angular.forEach($scope.CostCenters, function (cst) {
                                if (cst.IsAuto) {
                                    var temp = {
                                        Id: 0,
                                        Name: $scope.AccountNumber,
                                        Code: ""
                                    };
                                    cst.CostCenters.push(temp);
                                    cst.SelectedCostCenterId = 0;
                                }
                            });
                        });

                        angular.forEach($scope.StockIssue.StockJVDetails, function (e) {
                            e.CostCenters = angular.copy($scope.CostCenters);
                        });
                    });
                });
            }

            $scope.Units = [];
            MainService.UnitsInDropdown().then(function (response) {
                $scope.Units = response.data;
            });

             setTimeout(function () {
                    $scope.ReArrangeTable();
                }, 2000);
        };

        $scope.init();

        /////////////////////////////////Product//////////////

        $scope.productsMultiSearchDataSource = {
            type: "odata",
            serverFiltering: true,
            serverPaging: true,
            pageSize: 20,
            transport: {
                read: function (o) {
                    if (o.data.filter != undefined) {
                        if (o.data.filter.filters.length == 0) {
                        } else {
                            MainService.productInAutoComplete(o.data).then(
                                function (response) {
                                    var temp = {
                                        d: {
                                            results: response.data.Data,
                                            __count: response.data.Total
                                        }
                                    };
                                    o.success(temp);
                                },
                                function (err) {
                                    o.success({
                                        Data: []
                                    });
                                    toastr.error($scope.NetworkErrorLan);
                                }
                            );
                        }
                    } else {
                        var temp = {
                            d: {
                                results: [],
                                __count: 0
                            }
                        };
                        o.success(temp);
                    }
                }
            }
        };

        $scope.ProductMultiSearchOptions = {
            placeholder: "",
            dataTextField: "Name",
            dataValueField: "Name",
            filter: "contains",
            autoBind: false,
            minLength: 3,
            enforceMinLength: true,
            dropDownWidth: 700,
            dataSource: $scope.productsMultiSearchDataSource,
            columns: [
                {
                    field: "Name",
                    title: "Name",
                    width: "200px"
                },
                {
                    field: "ProductCode",
                    title: "Code",
                    width: "200px"
                },
                {
                    field: "BrandName",
                    title: "Brand"
                },
                {
                    field: "CountryName",
                    title: "Country"
                },
                {
                    field: "HSCode",
                    title: "HS Code"
                },
                {
                    field: "Balance",
                    title: "Balance"
                },
                {
                    field: "Weight",
                    title: "Weight"
                }
            ],
            select: function (data) {
                var data = this.dataItem(data.item.index());
                $scope.SelectedCE.Product = {};
                $scope.SelectedCE.Product.Name = data.Name;
                $scope.SelectedCE.Product.ProductCode = data.ProductCode;
                $scope.SelectedCE.ProductId = data.Id;
                $scope.SelectedCE.UnitId = data.UnitId;
                $scope.SelectedCE.UnitPrice = data.PurchasePrice;
                $scope.SelectedCE.CountryId = data.CountryId;
                $scope.SelectedCE.BrandId = data.BrandId;
                $scope.SelectedCE.Balance = data.Balance;
                $scope.SelectedCE.VATId = data.VATId;
                $scope.SelectedCE.UnitPrice = data.AveragePrice;
                $scope.$apply();
            }
        };

        $scope.ProductCodeMultiSearchOptions = {
            placeholder: "",
            dataTextField: "ProductCode",
            dataValueField: "ProductCode",
            filter: "contains",
            autoBind: false,
            minLength: 3,
            enforceMinLength: true,
            dropDownWidth: 700,
            dataSource: $scope.productsMultiSearchDataSource,
            columns: [
                {
                    field: "ProductCode",
                    title: "Code",
                    width: "200px"
                },
                {
                    field: "Name",
                    title: "Name",
                    width: "200px"
                },
                {
                    field: "BrandName",
                    title: "Brand"
                },
                {
                    field: "CountryName",
                    title: "Country"
                },
                {
                    field: "HSCode",
                    title: "HS Code"
                },
                {
                    field: "Balance",
                    title: "Balance"
                },
                {
                    field: "Weight",
                    title: "Weight"
                }
            ],
            select: function (data) {
                var data = this.dataItem(data.item.index());
                $scope.SelectedCE.Product = {};
                $scope.SelectedCE.Product.Name = data.Name;
                $scope.SelectedCE.Product.ProductCode = data.ProductCode;
                $scope.SelectedCE.ProductId = data.Id;
                $scope.SelectedCE.UnitId = data.UnitId;
                $scope.SelectedCE.UnitPrice = data.PurchasePrice;
                $scope.SelectedCE.CountryId = data.CountryId;
                $scope.SelectedCE.BrandId = data.BrandId;
                $scope.SelectedCE.Balance = data.Balance;
                $scope.SelectedCE.VATId = data.VATId;
                $scope.SelectedCE.UnitPrice = data.AveragePrice;
                $scope.$apply();
            }
        };

        $scope.ProductAutocompleteDataSource = {
            serverFiltering: true,
            transport: {
                read: function (o) {
                    if (o.data.filter.filters.length == 0) {
                        var temp = {
                            value: "",
                            operator: "contains",
                            field: "Name",
                            ignoreCase: true
                        };
                        o.data.filter.filters.push(temp);
                    }
                    MainService.productInAutoComplete(o.data).then(
                        function (response) {
                            o.success(response.data);
                        },
                        function (err) {
                            o.success({
                                Data: []
                            });
                            toastr.error($scope.NetworkErrorLan);
                        }
                    );
                }
            },
            schema: {
                data: "Data"
            },
            pageSize: 5
        };

        $scope.ProductAutocompleteOptions = {
            valuePrimitive: true,
            dataValueField: "Name",
            dataTextField: "Name",
            filter: "contains",
            placeholder: "",
            minLength: 2,
            select: function (data) {
                var data = this.dataItem(data.item.index());
                $scope.SelectedCE.Product = {};
                $scope.SelectedCE.Product.Name = data.Name;
                $scope.SelectedCE.Product.ProductCode = data.ProductCode;
                $scope.SelectedCE.ProductId = data.Id;
                $scope.SelectedCE.UnitId = data.UnitId;
                $scope.$apply();
            },
            minLength: 2,
            dataSource: $scope.ProductAutocompleteDataSource
        };

        $scope.ProductCodeAutocompleteOptions = {
            valuePrimitive: true,
            dataValueField: "ProductCode",
            dataTextField: "ProductCode",
            filter: "contains",
            placeholder: "",
            minLength: 2,
            select: function (data) {
                var data = this.dataItem(data.item.index());
                $scope.SelectedCE.Product = {};
                $scope.SelectedCE.Product.Name = data.Name;
                $scope.SelectedCE.Product.ProductCode = data.ProductCode;
                $scope.SelectedCE.ProductId = data.Id;
                $scope.SelectedCE.UnitId = data.UnitId;
                $scope.$apply();
            },
            minLength: 2,
            dataSource: $scope.ProductAutocompleteDataSource
        };

        $scope.CustomerAutocompleteDataSource = {
            serverFiltering: true,
            transport: {
                read: function (o) {
                    if (o.data.filter.filters.length == 0) {
                        var temp = {
                            value: "",
                            operator: "contains",
                            field: "Name",
                            ignoreCase: true
                        };
                        o.data.filter.filters.push(temp);
                    }
                    MainService.CustomerInAutoComplete(o.data).then(
                        function (response) {
                            o.success(response.data);
                        },
                        function (err) {
                            o.success({
                                Data: []
                            });
                            toastr.error("NetworkError");
                        }
                    );
                }
            },
            schema: {
                data: "Data"
            },
            pageSize: 5
        };

        $scope.CustomerAutocompleteOptions = {
            valuePrimitive: true,
            dataValueField: "Name",
            dataTextField: "Name",
            filter: "contains",
            placeholder: "",
            minLength: 2,
            select: function (data) {
                var data = this.dataItem(data.item.index());
                $scope.StockIssue.Customer = {};
                $scope.StockIssue.Customer.Name = data.Name;
                $scope.StockIssue.CustomerId = data.Id;
                $scope.$apply();
            },
            minLength: 2,
            dataSource: $scope.CustomerAutocompleteDataSource
        };

        $scope.checkProductionQty = function () {
            angular.forEach($scope.StockIssue.StockJVDetails, function (e) {
                if (e.ProductId > 0) {
                    $scope.click(e, 0);
                }
            });
        };

        $scope.click = function (data, temp) {
            $scope.SelectedCE = data;
            $scope.StockIssue.TotalQuantity = 0;
            $scope.StockIssue.TotalAmount = 0;

            if ($scope.SelectedCE.ProductId > 0) {
                MainService.ProductSummary($scope.SelectedCE.ProductId).then(function (response) {
                    if (response.data != null) {
                        $scope.SelectedCE.Balance = response.data.Balance;
                    }
                });
            }

            if ($scope.VDesign.Field1 == "Production Qty") {
                if ($scope.StockIssue.Field1 != null && $scope.StockIssue.Field1 != "") {
                    var val = parseFloat($scope.StockIssue.Field1);
                    if (val > 0 && $scope.SelectedCE.RecipeQuantity > 0) {
                        $scope.SelectedCE.Quantity = val * $scope.SelectedCE.RecipeQuantity;
                        $scope.SelectedCE.Quantity = parseFloat($scope.SelectedCE.Quantity.toFixed(5));
                    }
                }
            }

            if (temp == 10 && data.StockType == "Receive") {
                var uprice = 0;
                angular.forEach($scope.StockIssue.StockJVDetails, function (e) {
                    if (e.StockType == "Issue") {
                        uprice = uprice + e.TotalAmount;
                    }
                });

                data.UnitPrice = uprice / data.Quantity;
            }

            var pamt = 0;
            var namt = 0;

            var Field1 = 0;
            if (!isNaN(data.Field1)) {
                Field1 = parseFloat(data.Field1);
            }

            var Field2 = 0;
            if (!isNaN(data.Field2)) {
                Field2 = parseFloat(data.Field2);
            }

            var Field3 = 0;
            if (!isNaN(data.Field3)) {
                Field3 = parseFloat(data.Field3);
            }

            var Field4 = 0;
            if (!isNaN(data.Field4)) {
                Field4 = parseFloat(data.Field4);
            }

            var Field5 = 0;
            if (!isNaN(data.Field5)) {
                Field5 = parseFloat(data.Field5);
            }

            if ($scope.VoucherSet.IsNegativeField1) {
                namt = namt + Field1;
            } else {
                pamt = pamt + Field1;
            }

            if ($scope.VoucherSet.IsNegativeField2) {
                namt = namt + Field2;
            } else {
                pamt = pamt + Field2;
            }

            if ($scope.VoucherSet.IsNegativeField3) {
                namt = namt + Field3;
            } else {
                pamt = pamt + Field3;
            }

            if ($scope.VoucherSet.IsNegativeField4) {
                namt = namt + Field4;
            } else {
                pamt = pamt + Field4;
            }

            if ($scope.VoucherSet.IsNegativeField5) {
                namt = namt + Field5;
            } else {
                pamt = pamt + Field5;
            }

            data.TotalAmount = data.Quantity * data.UnitPrice + pamt - namt;
            data.TotalAmount = Math.round(data.TotalAmount * 100) / 100;

            angular.forEach($scope.StockIssue.StockJVDetails, function (e) {
                if (e.ProductId > 0) {
                    $scope.StockIssue.TotalQuantity = $scope.StockIssue.TotalQuantity + e.Quantity;
                    $scope.StockIssue.TotalAmount = $scope.StockIssue.TotalAmount + e.TotalAmount;
                }
            });

            $scope.StockIssue.TotalAmount = Math.round($scope.StockIssue.TotalAmount * 100) / 100;

            var a = $scope.StockIssue.StockJVDetails.indexOf(data);

            if ($scope.StockIssue.StockJVDetails.length - 1 == a) {
                var StockJVDetails = {
                    Id: 0,
                    Quantity: 0,
                    UnitPrice: 0,
                    TotalAmount: 0,
                    UnitId: "",
                    StockType: "",
                    Field1: 0,
                    Field2: 0,
                    Field3: 0,
                    Field4: 0,
                    Field5: 0,
                    ProductId: "",
                    Remark: "",
                    Product: {}
                };
                $scope.StockIssue.StockJVDetails.push(StockJVDetails);
            }
        };

        $scope.IsSavePrint = false;

        $scope.SaveVocuher = function (pval) {
            $scope.IsSavePrint = false;
            if (pval == 2) {
                $scope.IsSavePrint = true;
            }

            $scope.StockIssue.DateString = $scope.extractDate($scope.StockIssue.Date);
            if ($scope.StockIssue.Field16 != null) {
                $scope.StockIssue.F16DateString = $scope.extractDate($scope.StockIssue.Field16);
            }
            if ($scope.StockIssue.Field17 != null) {
                $scope.StockIssue.F17DateString = $scope.extractDate($scope.StockIssue.Field17);
            }
            if ($scope.StockIssue.Field18 != null) {
                $scope.StockIssue.F18DateString = $scope.extractDate($scope.StockIssue.Field18);
            }
            if ($scope.StockIssue.Field19 != null) {
                $scope.StockIssue.F19DateString = $scope.extractDate($scope.StockIssue.Field19);
            }
            if ($scope.StockIssue.Field20 != null) {
                $scope.StockIssue.F20DateString = $scope.extractDate($scope.StockIssue.Field20);
            }

            $scope.ErrorText = "";
            var count = 0;
            angular.forEach($scope.StockIssue.StockJVDetails, function (e) {
                if (e.ProductId > 0 && e.Price <= 0) {
                    $scope.ErrorText = "Invalid Details ";
                }
                if (e.ProductId > 0 && e.StockType == "") {
                    $scope.ErrorText = "Invalid Details ";
                }
                if (e.ProductId > 0) {
                    count = 1;
                }

                if (e.Field16 != null) {
                    e.F16DateString = $scope.extractDate(e.Field16);
                }
                if (e.Field17 != null) {
                    e.F17DateString = $scope.extractDate(e.Field17);
                }
                if (e.Field18 != null) {
                    e.F18DateString = $scope.extractDate(e.Field18);
                }
                if (e.Field19 != null) {
                    e.F19DateString = $scope.extractDate(e.Field19);
                }
                if (e.Field20 != null) {
                    e.F20DateString = $scope.extractDate(e.Field20);
                }

                if (e.ProductId > 0) {
                    e.StockJVCosts = [];
                    angular.forEach(e.CostCenters, function (a) {
                        if (a.Section == "Body") {
                            if (a.IsMandatory && !a.SelectedCostCenterId > 0) {
                                $scope.ErrorText = "Cost Center Not Selected For : " + a.CostCenter.Name;
                            } else {
                                if (a.SelectedCostCenterId > 0) {
                                    var cst = {
                                        CostCenterId: a.SelectedCostCenterId
                                    };
                                    e.StockJVCosts.push(cst);
                                    console.log(e);
                                }
                            }
                        }
                    });
                }
            });

            $scope.StockIssue.StockJVCosts = [];
            angular.forEach($scope.CostCenters, function (e) {
                if (e.Section == "Head") {
                    if (e.IsMandatory && !e.SelectedCostCenterId > 0) {
                        $scope.ErrorText = "Cost Center Not Selected For : " + e.CostCenter.Name;
                    } else {
                        if (e.SelectedCostCenterId > 0) {
                            var cst = {
                                CostCenterId: e.SelectedCostCenterId
                            };
                            $scope.StockIssue.StockJVCosts.push(cst);
                        }
                    }
                }
            });

            if (count == 0) {
                toastr.warning("No Details Found");
                $scope.ErrorText = "No Data";
            }

            if ($scope.VDesign != null) {
                if ($scope.VoucherDocs.length == 0 && $scope.VDesign.IsAttachmentMandatory) {
                    $scope.ErrorText = "Attachment Missing";
                }
            }

            if (!$scope.PageAccessInfo.IsAdd && !$scope.StockIssue.Id > 0) {
                toastr.info("You Dont Have Access To Add Data, Please Contact Admin");
            } else if (!$scope.PageAccessInfo.IsEdit && $scope.StockIssue.Id > 0) {
                toastr.info("You Dont Have Access To Edit Data, Please Contact Admin");
            } else {
                if ($scope.ErrorText == "") {
                    $("#mymodal2").modal("show");
                }
            }
        };

        $scope.SaveWithConfirm = function () {
            $scope.Load = true;
            $scope.StockIssue.VoucherNo = $scope.AccountNumber;
            $scope.StockIssue.VoucherDocs = $scope.VoucherDocs;

            var VoucherData = angular.copy($scope.StockIssue);
            angular.forEach(VoucherData.StockJVDetails, function (e) {
                e.CostCenters = [];
            });

            MainService.AddStockJV(VoucherData).then(
                function (response) {
                    if (response.data.Message == "Success") {
                        $scope.Load = false;
                        toastr.success("Success");
                        $("#mymodal2").modal("hide");
                        if ($scope.IsSavePrint == true) {
                            toastr.info("Printing");
                            $scope.PrintInvoice(response.data.Id, "Stock JV",$scope.AccountNumber);
                        }
                        $scope.refreshpageSave();
                    } else {
                        $scope.Load = false;
                        toastr.warning("Failed");
                    }
                },
                function (err) {
                    toastr.error("Error");
                    $scope.Load = false;
                }
            );
        };

        $scope.refreshpageSave = function () {
            if ($stateParams.VoucherId > 0) {
                $state.go("StockJV");
            } else {
                $scope.init();
            }
        };

        $scope.DeleteVoucher = function () {
            if (!$scope.PageAccessInfo.IsRemove) {
                toastr.info("You Dont Have Access To Delete Data, Please Contact Admin");
            } else {
                $("#myModal").modal("show");
            }
        };

        $scope.deleteWithConfirm = function () {
            $scope.Load = true;
            MainService.DeleteStockJV($scope.StockIssue.Id).then(
                function (response) {
                    if (response) {
                        $scope.Load = false;
                        toastr.success("Success");
                        $("#myModal").modal("hide");
                        $scope.init();
                    }
                },
                function () {
                    toastr.error("NetworkError");
                    $scope.working = false;
                    $scope.Load = false;
                }
            );
        };

        //// for context menu

        $scope.ClickedRow = {};
        $scope.ShowContextMenu = function (data) {
            $scope.ClickedRow = data;
        };

        $scope.InsertRow = function () {
            var StockJVDetails = {
                Id: 0,
                Quantity: 0,
                UnitPrice: 0,
                TotalAmount: 0,
                UnitId: "",
                StockType: "",
                Field1: 0,
                Field2: 0,
                Field3: 0,
                Field4: 0,
                Field5: 0,
                ProductId: "",
                Remark: "",
                Product: {}
            };

            $scope.StockIssue.StockJVDetails.push(StockJVDetails);
        };

        $scope.deleteRow = function () {
            var index = $scope.StockIssue.StockJVDetails.indexOf($scope.ClickedRow);
            $scope.StockIssue.StockJVDetails.splice(index, 1);
        };

        $scope.GetBackStockIssue = function (type) {
            var temp = 0;
            if ($scope.StockIssue.Id > 0) {
                temp = $scope.StockIssue.Id;
            }
            $scope.Load = true;
            $.LoadingOverlay("show", {
                image: "images/load.gif"
            });
            MainService.GetBackStockJV(temp, type).then(
                function (response) {
                    if (response.data > 0) {
                        $scope.loadVoucher(response.data);
                    } else {
                        $scope.init();
                    }
                    $scope.Load = false;
                    $.LoadingOverlay("hide");
                },
                function () {
                    toastr.error("NetworkError");
                    $scope.Load = false;
                    $.LoadingOverlay("hide");
                }
            );
        };

        $scope.$on("refreshCostCenterDir", function (e, id) {
            angular.forEach($scope.CostCenters, function (cost) {
                if (cost.CostCenterId == id) {
                    $.LoadingOverlay("show", {
                        image: "images/load.gif"
                    });
                    MainService.CostCenterSubList(id).then(
                        function (response) {
                            if (response.data != null) {
                                cost.CostCenters = response.data;
                                angular.forEach($scope.StockIssue.StockJVDetails, function (d) {
                                    angular.forEach(d.CostCenters, function (dd) {
                                        if (dd.CostCenterId == id) {
                                            dd.CostCenters = response.data;
                                        }
                                    });
                                });
                            }
                            $.LoadingOverlay("hide");
                        },
                        function () {
                            toastr.error("Network Error");
                            $.LoadingOverlay("hide");
                        }
                    );
                }
            });
        });

        /////////////////// Attachment //////////////////

        $scope.VoucherDocs = [];
        $scope.initAttachment = function () {
            $scope.VAttachment = {
                ExpiryDate: null,
                FileName: "",
                FilePath: "",
                Remarks: "",
                IsActive: true
            };
        };
        $scope.initAttachment();

        $scope.addAttachmentList = function () {
            if ($scope.VAttachment.FilePath == "") {
                toastr.warning("Upload File");
            } else if ($scope.VAttachment.FileName == "") {
                toastr.warning("Enter File Name");
            } else {
                $scope.VoucherDocs.push($scope.VAttachment);
                $scope.initAttachment();
            }
        };

        $scope.removeAttachmentRow = function (data) {
            data.IsActive = false;
        };

        // file upload
        $scope.files = [];
        $scope.getFileDetails = function (e) {
            $scope.files = [];
            $scope.$apply(function () {
                for (var i = 0; i < e.files.length; i++) {
                    $scope.files.push(e.files[i]);
                }
            });
            $scope.Load = true;
            $scope.uploadFiles();
        };
        $scope.remove = function (file) {
            var index = $scope.files.indexOf(file);
            $scope.files.splice(index, 1);
        };
        $scope.uploadFiles = function () {
            var data = new FormData();
            for (var i in $scope.files) {
                data.append("uploadedFile", $scope.files[i]);
            }
            var objXhr = new XMLHttpRequest();
            objXhr.onreadystatechange = function () {
                if (objXhr.readyState == XMLHttpRequest.DONE) {
                    if (objXhr.responseText != null && objXhr.responseText != "") {
                        $scope.VAttachment.FilePath = objXhr.responseText;
                        if ($scope.VAttachment.FilePath.includes("error")) {
                            $scope.VAttachment.FilePath = "";
                            toastr.error($scope.LanguageData.UploadError);
                        } else {
                            $scope.VAttachment.FilePath = objXhr.responseText;
                            toastr.success($scope.LanguageData.FileUploaded);
                        }
                    } else {
                    }
                }
            };
            // objXhr.addEventListener("progress", updateProgress, false);
            objXhr.addEventListener("load", transferComplete, false);
            if ($scope.files.length > 0) {
                toastr.info($scope.LanguageData.FileUploadingPleaseWait);
                objXhr.open("POST", config.basePath + "UploadFiles");
                objXhr.send(data);
            } else {
                toastr.error($scope.LanguageData.UploadError);
            }
        };
        //function updateProgress(e) {
        //    if (e.lengthComputable) {
        //        document.getElementById('pro').setAttribute('value', e.loaded);
        //        document.getElementById('pro').setAttribute('max', e.total);
        //    }
        //}
        function transferComplete(e) {
            $scope.Load = false;
        }

        $scope.FieldAutoCompleteDataSource = {
            serverFiltering: true,
            transport: {
                read: function (o) {
                    if (o.data.filter.filters.length > 0) {
                        o.data.FieldVoucherName = "Credit Note SR";
                        if (o.data.filter.filters.length == 0) {
                            var temp = {
                                value: "",
                                operator: "contains",
                                field: "Name",
                                ignoreCase: true
                            };
                            o.data.filter.filters.push(temp);
                        }
                        MainService.FieldAutoComplete(o.data).then(
                            function (response) {
                                o.success(response.data);
                            },
                            function (err) {
                                o.success({
                                    Data: []
                                });
                                toastr.error("Network Error");
                            }
                        );
                    } else {
                        o.success({
                            Data: []
                        });
                    }
                }
            },
            schema: {
                data: "Data"
            },
            pageSize: 10
        };

        $scope.FieldAutoCompleteOptions11 = {
            valuePrimitive: true,
            dataValueField: "Field11",
            dataTextField: "Field11",
            filter: "contains",
            placeholder: "",
            minLength: 2,
            select: function (data) {
                var data = this.dataItem(data.item.index());
                $scope.StockIssue.Field11 = data.Field11;
                $scope.$apply();
            },
            minLength: 2,
            dataSource: $scope.FieldAutoCompleteDataSource
        };
        $scope.FieldAutoCompleteOptions12 = {
            valuePrimitive: true,
            dataValueField: "Field12",
            dataTextField: "Field12",
            filter: "contains",
            placeholder: "",
            minLength: 2,
            select: function (data) {
                var data = this.dataItem(data.item.index());
                $scope.StockIssue.Field12 = data.Field12;
                $scope.$apply();
            },
            minLength: 2,
            dataSource: $scope.FieldAutoCompleteDataSource
        };
        $scope.FieldAutoCompleteOptions13 = {
            valuePrimitive: true,
            dataValueField: "Field13",
            dataTextField: "Field13",
            filter: "contains",
            placeholder: "",
            minLength: 2,
            select: function (data) {
                var data = this.dataItem(data.item.index());
                $scope.StockIssue.Field13 = data.Field13;
                $scope.$apply();
            },
            minLength: 2,
            dataSource: $scope.FieldAutoCompleteDataSource
        };
        $scope.FieldAutoCompleteOptions14 = {
            valuePrimitive: true,
            dataValueField: "Field14",
            dataTextField: "Field14",
            filter: "contains",
            placeholder: "",
            minLength: 2,
            select: function (data) {
                var data = this.dataItem(data.item.index());
                $scope.StockIssue.Field14 = data.Field14;
                $scope.$apply();
            },
            minLength: 2,
            dataSource: $scope.FieldAutoCompleteDataSource
        };
        $scope.FieldAutoCompleteOptions15 = {
            valuePrimitive: true,
            dataValueField: "Field15",
            dataTextField: "Field15",
            filter: "contains",
            placeholder: "",
            minLength: 2,
            select: function (data) {
                var data = this.dataItem(data.item.index());
                $scope.StockIssue.Field15 = data.Field15;
                $scope.$apply();
            },
            minLength: 2,
            dataSource: $scope.FieldAutoCompleteDataSource
        };

        $scope.DFieldAutoCompleteDataSource = {
            serverFiltering: true,
            transport: {
                read: function (o) {
                    if (o.data.filter.filters.length > 0) {
                        o.data.FieldVoucherName = "Credit Note SR";
                        if (o.data.filter.filters.length == 0) {
                            var temp = {
                                value: "",
                                operator: "contains",
                                field: "Name",
                                ignoreCase: true
                            };
                            o.data.filter.filters.push(temp);
                        }
                        MainService.FieldAutoCompleteDetail(o.data).then(
                            function (response) {
                                o.success(response.data);
                            },
                            function (err) {
                                o.success({
                                    Data: []
                                });
                                toastr.error("Network Error");
                            }
                        );
                    } else {
                        o.success({
                            Data: []
                        });
                    }
                }
            },
            schema: {
                data: "Data"
            },
            pageSize: 10
        };

        $scope.D11AutoCompleteOptions = {
            valuePrimitive: true,
            dataValueField: "Field11",
            dataTextField: "Field11",
            filter: "contains",
            placeholder: "",
            minLength: 2,
            select: function (data) {
                var data = this.dataItem(data.item.index());
                $scope.SelectedCE.Field11 = data.Field11;
                $scope.$apply();
            },
            minLength: 2,
            dataSource: $scope.DFieldAutoCompleteDataSource
        };

        $scope.D12AutoCompleteOptions = {
            valuePrimitive: true,
            dataValueField: "Field12",
            dataTextField: "Field12",
            filter: "contains",
            placeholder: "",
            minLength: 2,
            select: function (data) {
                var data = this.dataItem(data.item.index());
                $scope.SelectedCE.Field12 = data.Field12;
                $scope.$apply();
            },
            minLength: 2,
            dataSource: $scope.DFieldAutoCompleteDataSource
        };

        $scope.D13AutoCompleteOptions = {
            valuePrimitive: true,
            dataValueField: "Field13",
            dataTextField: "Field13",
            filter: "contains",
            placeholder: "",
            minLength: 2,
            select: function (data) {
                var data = this.dataItem(data.item.index());
                $scope.SelectedCE.Field13 = data.Field13;
                $scope.$apply();
            },
            minLength: 2,
            dataSource: $scope.DFieldAutoCompleteDataSource
        };

        $scope.D14AutoCompleteOptions = {
            valuePrimitive: true,
            dataValueField: "Field14",
            dataTextField: "Field14",
            filter: "contains",
            placeholder: "",
            minLength: 2,
            select: function (data) {
                var data = this.dataItem(data.item.index());
                $scope.SelectedCE.Field14 = data.Field14;
                $scope.$apply();
            },
            minLength: 2,
            dataSource: $scope.DFieldAutoCompleteDataSource
        };

        $scope.D15AutoCompleteOptions = {
            valuePrimitive: true,
            dataValueField: "Field15",
            dataTextField: "Field15",
            filter: "contains",
            placeholder: "",
            minLength: 2,
            select: function (data) {
                var data = this.dataItem(data.item.index());
                $scope.SelectedCE.Field15 = data.Field15;
                $scope.$apply();
            },
            minLength: 2,
            dataSource: $scope.DFieldAutoCompleteDataSource
        };
    }
]);
